import { DetectorMap, Lane, Link } from "NSwag/ServerClient/Client.nswag";

/**
 * Returns an object mapping all lane id.name to the lane object from the given detector map.
 * @param {any} detectorMap - the detector map to parse
 */
export const parseLanesFromDetectorMapping = (detectorMap: DetectorMap): Lane[] => {
    return detectorMap.links!.reduce<Lane[]>((lanes, link) => ([
        ...lanes,
        ...link.lanes!
    ]), []);
}

/**
 * Returns an object mapping all link id.name to the lane object.  The lane object has
 * its lanes array reduced to an array of the lanes id.name.
 * @param {any} detectorMap - the detector map to parse
 */
export const parseLinksFromDetectorMapping = (detectorMap: DetectorMap): Link[] => {
    return detectorMap.links!.reduce<Link[]>((links, link) => ([
        ...links,
        link
    ]), []);
}